<div id="flashMessages" class="flash-messages">
  @if (_grayOut && messages.length) {
    <div id="grayOutDiv"></div>
  }
  @for (message of messages; track message) {
    <div class="alert flash-message {{ message.cssClass }}" [ngClass]="{ 'alert-dismissible': message.showCloseBtn }" [style.cursor]="message.closeOnClick ? 'pointer' : 'inherit'" (click)="alertClicked(message)">
      @if (message.showCloseBtn) {
        <p-button type="button" styleClass="close" data-dismiss="alert" aria-label="Close" (Onclick)="close(message)"><span aria-hidden="true">&times;</span></p-button>
      }
      <div [innerHTML]="message.text"></div>
    </div>
  }
</div>
